<template>
  <div>
    <el-table ref="multipleTable"
              :data="trafficPlanData"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange">
      <!-- 选择器 -->
      <el-table-column type="selection"
                       width="45">
      </el-table-column>
      <!-- ID -->
      <el-table-column label="ID"
                       prop="traffic_plan_id"
                       width="45">
      </el-table-column>
      <!-- 名称 -->
      <el-table-column label="方案名称"
                       width="100">
        <template slot-scope="scope">
          <div> {{scope.row.traffic_plan_name}}</div>
          <div>
            <el-tag size="mini"
                    v-if="scope.row.traffic_type=='walking'">徒步</el-tag>
            <el-tag size="mini"
                    v-else-if="scope.row.traffic_type=='bicycling'">骑行</el-tag>
            <el-tag size="mini"
                    v-else-if="scope.row.traffic_type=='driving'">驾车
            </el-tag>
            <el-tag size="mini"
                    v-else-if="scope.row.traffic_type=='transit'">公共交通
            </el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="方案内容"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-html="scope.row.traffic_introduce"></div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'select-traffic-plan',
  data() {
    return {
      trafficPlanData: this.TrafficPlanData,
    }
  },
  props: {
    TrafficPlanData: Array,
  },
  watch: {
    TrafficPlanData(newVal) {
      this.trafficPlanData = newVal
    },
  },
  methods: {
    handleSelectionChange(traffic_plan_list) {
      console.log('选择的方案', traffic_plan_list)
      //
      // content_id_list: null
      // content_num: null
      // take_taxi: "物质州岛码头"
      // traffic_id: 1
      // traffic_introduce: "<p>距离：3.815公里，耗时约：58分钟,非常适合自己的公路很棒哦！</p>"
      // traffic_plan_id: 3
      // traffic_plan_name: "自驾方案"
      // traffic_type: "walking"

      this.$emit('selectTrafficPlan', traffic_plan_list)
    },
  },
}
</script>

<style>
</style>